module.exports = __webpack_public_path__ + "static/media/tsys.337e1c67.png";